import {
  MonthlyReportFineAggRValue,
  MonthlyReportNameEnum,
  ResultAndIsAbnormal,
} from '@Src/_basic/object/MonthlyReportType';
import { MonthlyReportApi } from '@Src/_basic/protocol/monthlyReport/MonthlyReportApi';
import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MonthlyReportSelect from '../components/MonthlyReportSelect';

const FineAggregateRValue = () => {
  const { t: i18T } = useTranslation();
  const [tableData, setTableData] = useState<Array<MonthlyReportFineAggRValue<ResultAndIsAbnormal<number>>>>([]);

  const selectHandler = useCallback((factoryId: number, exptUnitId: number, startTime: number, endTime: number) => {
    if (!factoryId || !exptUnitId || !startTime || !endTime) return;

    MonthlyReportApi.getFineAggRValue(
      {
        factoryId,
        exptUnitId,
        startTime,
        endTime,
      },
      (_data) => setTableData(_data),
    );
  }, []);

  return (
    <MonthlyReportSelect
      title={i18T('REPORT.MONTHLY_REPORT.FINE_AGGREGATE_R_VALUE.TITLE')}
      exptType={MonthlyReportNameEnum.FINE_AGGREGATE_R_VALUE}
      selectHandler={selectHandler}
      tableData={tableData}
    />
  );
};

export default memo(FineAggregateRValue);
